import React from "react";
import OrderAlert from "../../components/OrderSuccess/OrderAlert"

const OrderSuccessful = () => {
  return (
  <OrderAlert/>
  );
};

export default OrderSuccessful;

